import React from "react"

const STATS = [
  ["~87", "Subnational Units"],
  ["3", "Federal Countries"],
  ["40+", "Years of Data"],
]

export default function SppAbout() {
  return (
    <section style={wrap} id="spp">
      <h2 style={titleStyle}>Subnational Politics Project</h2>
      <div style={grid} className="spp-grid">
        <div style={textCol} className="spp-text-col">
          <p style={para}>
            The <strong>Subnational Politics Project (SPP)</strong> is a collaborative initiative
            dedicated to compiling, generating, and disseminating systematic, transparent, and
            publicly accessible data on subnational political institutions, processes, and electoral
            outcomes across Latin America.
          </p>
          <p style={para}>
            The SPP's central goal is to build a comprehensive and standardized data infrastructure
            that enables both detailed within-country analysis and robust cross-national comparisons
            of subnational political dynamics.
          </p>
          <p style={para}>
            By providing consistent and high-quality data, SPP seeks to advance scholarly and
            policy-oriented research on the political foundations and consequences of territorial
            inequality in the region.
          </p>
          <div style={btnRow} className="spp-btn-row">
            <a href="http://subnationalpolitics.com/" target="_blank" rel="noreferrer" style={btnPrimary}>
              Explore the Project
            </a>
            <a href="https://dataverse.harvard.edu/dataverse/spp" target="_blank" rel="noreferrer" style={btnOutline}>
              Download Data
            </a>
          </div>
        </div>
        <div style={gifCol} className="spp-gif-col">
          <img src="/dashboard-demo.webp" alt="SPP Dashboard Demo" style={gifStyle} loading="lazy" />
          <div style={statsRow}>
            {STATS.map(([num, label]) => (
              <div key={label} style={stat}>
                <div style={statNum}>{num}</div>
                <div style={statLabel}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .spp-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
          .spp-gif-col { display: none !important; }
        }
        @media (max-width: 600px) {
          .spp-text-col p { text-align: justify !important; }
          .spp-btn-row { flex-wrap: nowrap !important; gap: 10px !important; }
          .spp-btn-row a { padding: 11px 14px !important; font-size: 10px !important; letter-spacing: 0.14em !important; white-space: nowrap !important; flex: 1 1 auto !important; text-align: center !important; }
        }
      `}</style>
    </section>
  )
}

const wrap = {
  padding: "96px 40px 96px 40px",
  maxWidth: "1320px",
  margin: "0 auto",
  overflowX: "visible",
}

const titleStyle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 300,
  fontSize: "32px",
  letterSpacing: "0.04em",
  color: "var(--cobalt)",
  marginBottom: "48px",
  lineHeight: 1.2,
}

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "80px",
  alignItems: "start",
}

const textCol = {
  fontSize: "18px",
  lineHeight: 1.75,
  color: "var(--ink)",
}

const para = {
  marginBottom: "20px",
}

const statsRow = {
  display: "flex",
  gap: "40px",
  margin: "32px 0",
  flexWrap: "wrap",
}

const stat = {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}

const statNum = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 300,
  fontSize: "40px",
  color: "var(--cobalt)",
  letterSpacing: "-0.01em",
  lineHeight: 1,
}

const statLabel = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "10px",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "var(--ink-soft)",
}

const btnRow = {
  display: "flex",
  gap: "16px",
  flexWrap: "wrap",
  marginTop: "8px",
}

const btnPrimary = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 400,
  fontSize: "11px",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  background: "var(--cobalt)",
  color: "white",
  padding: "13px 28px",
  textDecoration: "none",
  display: "inline-block",
}

const btnOutline = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 400,
  fontSize: "11px",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  background: "transparent",
  color: "var(--cobalt)",
  padding: "13px 28px",
  textDecoration: "none",
  border: "1px solid var(--cobalt)",
  display: "inline-block",
}

const gifCol = {}

const gifStyle = {
  width: "calc(100% + 40px)",
  display: "block",
  marginBottom: "24px",
  boxShadow: "0 8px 32px rgba(28,54,116,0.15)",
}
